import { useLocation, useNavigate } from "react-router-dom";
import { Button, Typography } from "../components/common";

const APP_LOGIN_URL = process.env.REACT_APP_APP_HOME_URL
  ? `${process.env.REACT_APP_APP_HOME_URL}/login`
  : "https://app.pedagogue.io/login";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const message = (location.state as { message?: string } | null)?.message;

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <Typography variant="h1" weight="bold" className="text-red-600">
        403
      </Typography>
      <Typography variant="h2" weight="medium" className="mt-4">
        Access Denied
      </Typography>
      <Typography variant="p" className="my-2 text-center max-w-md">
        {message || "You don't have permission to access this page. This area is restricted to administrators only."}
      </Typography>
      <div className="flex gap-4 mt-6">
        <Button onClick={() => navigate("/")} variant="filled" size="large">
          Go Home
        </Button>
        <Button
          onClick={() => { window.location.href = APP_LOGIN_URL; }}
          variant="outline"
          size="large"
        >
          Sign In
        </Button>
      </div>
    </div>
  );
};

export default Unauthorized;
